export default __webpack_public_path__ + "static/media/slide2.98c28faa.jpg";